import { Injectable, OnInit } from "@angular/core";
import { GeneralService } from "../../shared/services/general.service";
import { ApiService } from "../../core/services/api.service";
import { Category, SubCategory } from "./categories.model";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/forkJoin";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

@Injectable()
export class CategoriesService {
  constructor(
    private apiService: ApiService,
    private generalService: GeneralService
  ) {}

  getCategories(): Observable<any> {
    return this.retrieveCategories().map((categories) =>
      this.translateCategories(categories)
    );
  }

  private retrieveCategories(): Observable<any> {
    return this.apiService.get("/interfacedata/modules/categories").map((res) =>
      Category.fromDTOWrapper(res).sort((v1, v2) => {
        const order1 = v1.getName();
        const order2 = v2.getName();
        if (order1 < order2) {
          return -1;
        } else if (order1 > order2) {
          return 1;
        } else {
          return 0;
        }
      })
    );
  }

  translateCategories(categories: Category[]) {
    const observables: Observable<any>[] = [];
    categories.forEach((category) => {
      observables.push(
        this.generalService.translate
          .get(category.getName())
          .map((translatedName) => {
            category.setName(translatedName);
            category.subCategories.forEach((subCategory) => {
              this.generalService.translate
                .get(subCategory.getName())
                .subscribe((translateSubName) => {
                  subCategory.setName(translateSubName);
                });
            });
            return category;
          })
      );
    });
    return Observable.forkJoin(observables);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/categories.service.ts